import { useDispatch, useSelector } from 'react-redux';
import { setFlagIsAppView } from '../actions/content';

const useReferrerParam = () => {
  const dispatch = useDispatch();
  const isAppView = useSelector((state) => state?.content?.flags?.isAppView);
  const params = new URLSearchParams(window.location.search);

  if (!isAppView && params.get('referrer') === 'app') {
    dispatch(setFlagIsAppView(true));
  }

  return isAppView;
};

export default useReferrerParam;
